<ul>
    <li *ngFor="let p of programs" [class]="{active: selected.indexOf(p.id)> -1}" (click)="itemClicked(p)"><i class="fa fa-check mr-2"></i>{{p.name}} - <strong>{{p.batch_code}}</strong></li>
</ul>
<app-spinner *ngIf="loading"></app-spinner>
